export const skills = [
  {
    category: "Languages",
    items: [
      { name: "Python", level: 85 },
      { name: "JavaScript", level: 80 },
      { name: "C++", level: 75 },
      { name: "C", level: 70 }
    ]
  },
  {
    category: "Frameworks & Libraries",
    items: [
      { name: "React", level: 80 },
      { name: "Node.js", level: 75 },
      { name: "Express.js", level: 70 }
    ]
  },
  {
    category: "Web Technologies",
    items: [
      { name: "HTML5", level: 90 },
      { name: "CSS3", level: 85 },
      { name: "RESTful APIs", level: 80 },
      { name: "MongoDB", level: 75 }
    ]
  },
  {
    category: "Tools & Platforms",
    items: [
      { name: "Git", level: 85 },
      { name: "GitHub", level: 80 },
      { name: "VS Code", level: 90 },
      { name: "Postman", level: 75 }
    ]
  }
];